import React, { useState, useEffect } from "react";
import { PrintProduct } from "../CheckoutPage/components/types";
import AddToCartButton from "./AddToCartButton";
import RemoveFromCartButton from "./RemoveFromCartButton";

interface PrintLightboxHeaderProps {
  photo: any;
  eventId: number;
  addToCart: (photo: any) => void;
  removeFromCart?: (photo: any) => void;
  primaryColor?: string;
}

const PrintLightboxHeader: React.FC<PrintLightboxHeaderProps> = ({
  photo,
  eventId,
  addToCart,
  removeFromCart,
  primaryColor = "#259fa5"
}) => {
  const [printProducts, setPrintProducts] = useState<PrintProduct[]>([]);
  const [loading, setLoading] = useState(false);
  const [showProducts, setShowProducts] = useState(false);

  const fetchPrintProducts = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `/api/v1/events/${eventId}/print_products`
      );
      if (response.ok) {
        const data = await response.json();
        setPrintProducts(data.printProducts || data || []);
      }
    } catch (error) {
      console.error("Error fetching print products:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price: number | string, currency: string) => {
    const numericPrice = typeof price === "string" ? parseFloat(price) : price;
    if (isNaN(numericPrice) || numericPrice == null) {
      return `$0.00 ${currency}`;
    }
    return `$${numericPrice.toFixed(2)} ${currency}`;
  };

  const handleViewPriceList = async () => {
    setShowProducts(true);
    if (printProducts.length === 0) {
      await fetchPrintProducts();
    }
  };

  const handleHidePriceList = () => {
    setShowProducts(false);
  };

  return (
    <div className="geo-print-header-mobile">
      {/* Action buttons at top */}
      <div className="geo-print-header-mobile__actions d-flex justify-content-between align-items-center">
        {photo.isSelected ? (
          <RemoveFromCartButton
            colorTheme={primaryColor}
            onRemoveFromCart={(photo) => {
              removeFromCart?.(photo);
            }}
            photo={photo}
          />
        ) : (
          <AddToCartButton
            colorTheme={primaryColor}
            onAddToCart={(photo) => {
              addToCart(photo);
            }}
            photo={photo}
          />
        )}
        <button
          onClick={showProducts ? handleHidePriceList : handleViewPriceList}
          className="geo-text-btn"
          style={{ color: primaryColor }}
        >
          {showProducts ? "Hide price list" : "View price list"}
        </button>
      </div>

      {/* Explanatory text below buttons */}
      <div className="geo-print-header-mobile__text">
        <div className="geo-print-header-mobile__main-text">
          You can <strong>customise products</strong> in Cart
        </div>
        <div className="geo-print-header-mobile__sub-text">
          once you add this photo to cart
        </div>
      </div>

      {/* Product list - expands below when showProducts is true */}
      {showProducts && (
        <div className="geo-print-header-mobile__products">
          {loading ? (
            <div className="text-center">Loading products...</div>
          ) : (
            <div className="geo-print-header-mobile__product-grid">
              {printProducts.map(product => (
                <div
                  key={product.id}
                  className="geo-print-header-mobile__product-row d-flex justify-content-between align-items-center"
                >
                  <div className="geo-print-header-mobile__product-name">
                    {product.title}
                  </div>
                  <div className="geo-print-header-mobile__product-price">
                    {formatPrice(product.totalPrice, product.currency)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PrintLightboxHeader;
